import { useMemo } from "react";
import { useAuth } from "react-oidc-context";
import { useTenant } from "../context/TenantContext";

export interface ApiError {
  status: number;
  error?: string;
  message?: string;
}

export function useApi() {
  const auth = useAuth();
  const { tenant } = useTenant();
  const token = auth.user?.access_token;

  return useMemo(() => {
    async function call<T = unknown>(
      path: string,
      init?: RequestInit & { tenant?: string | null },
    ): Promise<T> {
      const headers = new Headers(init?.headers as any);
      headers.set("Accept", "application/json");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      const t = init?.tenant !== undefined ? init.tenant : tenant;
      if (t) headers.set("X-Tenant", t);
      const res = await fetch(path, { ...init, headers });
      if (!res.ok) {
        let body: any = {};
        try {
          body = await res.json();
        } catch (_) {}
        const err: ApiError = { status: res.status, ...body };
        throw err;
      }
      return (await res.json()) as T;
    }
    return { call };
  }, [token, tenant]);
}
